<template>
  <div class="mt-10 ml-5">
    <v-row v-if="showtop">
      <v-tooltip color="success" top>
        <template v-slot:activator="{ on }">
          <v-btn
            small
            text
            color="accent"
            @click="sortBy('favorites')"
            v-on="on"
            slot="activator"
          >
            <v-icon small left>folder</v-icon>
            <span class="accent--text title text-lowercase">By favorites</span>
          </v-btn>
        </template>
        <span>Sort by favorites</span>
      </v-tooltip>
      <p
        v-if="nores != 'No Results'"
        class="text-h5 font-weight-black accent--text"
      >
        Poems: {{ total }}
      </p>
    </v-row>
    <div class="tablediv">
      <v-data-table
        :key="refresh"
        :headers="headers"
        :items="projects"
        :search="search"
        :custom-filter="filterOnlyLowText"
        :mobile-breakpoint="0"
        @pagination="updatePage"
        item-key="id"
        v-if="!dispdoc"
        fixed-header
        height="70vh"
        :page.sync="page"
        :items-per-page="itemsPerPage"
        :footer-props="{
          showCurrentPage: true,
          itemsPerPageText: 'Rows:',
          prevIcon: 'mdi-arrow-left',
          nextIcon: 'mdi-arrow-right',
        }"
        class="mr-5 mt-2 blogtable elevation-1"
      >
        <template v-slot:top>
          <label for="search">Search: </label>
          <input
            v-model="search"
            class="search-title"
            type="text"
            name="search"
            size="50"
            placeholder="(lower case only)"
          /><br /><br />
        </template>
        <template v-slot:body="{ items }">
          <tbody>
            <tr v-for="item in items" :key="item.name">
              <td
                v-if="item.favorite == 'N'"
                class="blogtitle"
                :class="{ active: cur_sele == item.id }"
                @click="editTxt(item.id)"
              >
                {{ item.title }}
              </td>
              <td
                v-if="item.favorite == 'Y'"
                class="blogtitle"
                :class="{ active: cur_sele == item.id }"
                @click="editTxt(item.id)"
              >
                <v-icon class="ma-0" color="accent" right>star</v-icon>
                {{ item.title }}
              </td>
              <td
                class="blogtitle"
                :class="{ active: cur_sele == item.id }"
                @click="editTxt(item.id)"
              >
                {{ item.topic }}
              </td>
            </tr>
          </tbody>
        </template>
      </v-data-table>
      <v-card v-if="dispdoc" row flat class="primary">
        <v-card-text class="mt-0 pt-0">
          <v-row>
            <v-col sm="9" md="9" lg="9" xl="9">
              <h1 class="mb-3 accent--text" v-html="curdoc.title"></h1>
            </v-col>
            <v-col>
              <v-btn
                large
                text
                color="accent"
                @click="(dispdoc = false), (pdffile = false), (showtop = true)"
              >
                <v-icon color="black" large left>close</v-icon>
                <span class="black--text title text-lowercase">Close</span>
              </v-btn>
            </v-col>
          </v-row>
          <hr class="accent thick mb-4 mr-5" />
          <div v-if="pdffile && curdoc.pdf">
            <iframe
              :src="
                pdfurl +
                  curdoc.pdf +
                  '#view=FitH,top,100&toolbar=1&navpanes=1&scrollbar=0&statusbar=1&messages=0'
              "
              frameborder="0"
            />
          </div>
          <v-row v-if="!pdffile" class="ml-5 mr-5">
            <v-col class="ck-content" sm="12" md="12" lg="10" xl="8">
              <div class="black--text mt-5" v-html="curdoc.content"></div>
            </v-col>
          </v-row>
          <h2 v-if="complist.length > 0" class="success--text ml-3 mt-3">
            Favorites
          </h2>
          <v-row
            dense
            no-gutters
            class="ml-3"
            v-for="(item, index) in complist"
            :key="item.id"
          >
            <v-col sm="3" md="3" lg="10" xl="10">
              <p v-if="item.favorite == 'N'" class="ml-2 mb-1 black--text">
                {{ item.title }}
              </p>
              <p v-if="item.favorite == 'Y'" class="ml-2 mb-1 black--text">
                {{ item.title }}
                <v-icon class="ma-0" color="accent" left>star</v-icon>
              </p>
              <v-divider class="accent mb-2" v-if="index == 2"> </v-divider>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
import { shared } from "../mixins/shared";
import ClassicEditor from "@ckeditor/ckeditor5-editor-classic/src/classiceditor";
import Image from "@ckeditor/ckeditor5-image/src/image";
import ImageToolbar from "@ckeditor/ckeditor5-image/src/imagetoolbar";
import ImageStyle from "@ckeditor/ckeditor5-image/src/imagestyle";
import ImageResize from "@ckeditor/ckeditor5-image/src/imageresize";
import ImageUpload from "@ckeditor/ckeditor5-image/src/imageupload";

export default {
  mixins: [shared],
  data() {
    return {
      headers: [
        {
          text: "Title",
          align: "start",
          sortable: true,
          value: "title",
          width: "50%",
        },
        { text: "First Line", value: "topic", width: "50%" },
      ],
      page: 1,
      itemsPerPage: 10,
      tid: "poems",
      pdfbtn: true,
      fcontent: "",
      ftitle: "",
      cur_sele: 0,
      total: 0,
      refresh: 0,
      projects: [],
      nores: "",
      playlist: [],
      complist: [],
      pdffile: false,
      picurl: "https://jamespaulgee.com/images/",
      pdfurl: "https://jamespaulgee.com/pdfs/",
      albums: 0,
      snackbar: false,
      snackbar2: false,
      snackbar3: false,
      snackbar4: false,
      dispdoc: false,
      showtop: true,
      curdoc: [],
      curid: 0,
      menu: false,
      menu2: false,
      search: "",
      total_playsa: 0,
      total_playsc: 0,
      total_comps: 0,
      total_albums: 0,
      editor: ClassicEditor,
      editorData: "",
      editor: ClassicEditor,
      editorData: "",
      editorConfig: {
        plugins: [Image, ImageToolbar, ImageStyle, ImageResize, ImageUpload],
        indentBlock: {
          offset: 1,
          unit: "em",
        },
        link: {
          decorators: {
            addTargetToExternalLinks: {
              mode: "automatic",
              callback: (url) => /^(https?:)?\/\//.test(url),
              attributes: {
                target: "_blank",
                rel: "noopener noreferrer",
              },
            },
          },
        },
        lineHeight: {
          // specify your otions in the lineHeight config object. Default values are [ 0, 0.5, 1, 1.5, 2 ]
          options: [0.5, 1, 1.5, 1.75, 2, 2.5],
        },
        image: {
          resizeUnit: "px",
          // You need to configure the image toolbar, too, so it uses the new style buttons.
          toolbar: [
            "imageTextAlternative",
            "|",
            "imageStyle:alignLeft",
            "imageStyle:alignCenter",
            "imageStyle:alignRight",
          ],

          styles: [
            "alignCenter",

            // This represents an image aligned to the left.
            "alignLeft",

            // This represents an image aligned to the right.
            "alignRight",
          ],
        },
        alignment: {
          options: ["left", "right"],
        },
        fontSize: {
          options: ["tiny", "default", "big"],
        },
      },
    };
  },
  methods: {
    filterOnlyLowText(value, search) {
      return (
        value != null &&
        search != null &&
        typeof value === "string" &&
        value
          .toString()
          .toLocaleLowerCase()
          .indexOf(search) !== -1
      );
    },
    updatePage(options) {
      this.itemsPerPage = options.itemsPerPage;
    },
    editTxt(id) {
      for (var i = 0; i < this.projects.length; i++) {
        if (this.projects[i].id === id) {
          this.curdoc.content = this.projects[i].content;
          this.curdoc.title = this.projects[i].title;
          this.curdoc.topic = this.projects[i].topic;
          this.cur_sele = id;
          this.dispdoc = true;
          this.showtop = false;
        }
      }
      this.forceRerender();
    },
  },
  created() {
    var url = "https://jamespaulgee.com/data.php";
    var formdata = {
      action: "displaypo",
      search: this.search,
      fld: this.fld,
      tid: this.tid,
    };
    this.axios
      .post(url, formdata, {
        headers: {
          "Content-Type": "text/plain",
        },
      })
      .then((res) => {
        const data = res.data;
        this.projects = data;
        this.nores = this.projects[0].title;
        this.total = this.projects.length;
        this.fcontent = this.projects[0].content;
        this.ftitle = this.projects[0].title;
        this.cur_sele = 0;
      })
      .catch((error) => alert(error));
  },
};
</script>

<style>
iframe {
  width: 100%;
  height: 1100px;
}
.tablediv {
  overflow: auto;
  width: 100%;
}
.content {
  height: 70vh;
  overflow: auto;
  padding-left: 2%;
  padding-right: 2%;
}

td.blogtitle {
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

td.blogtitle:hover {
  white-space: normal;
  width: auto;
}

.poem img {
  border: 5px solid #555;
}

.blogtable th,
.blogtable td {
  font-size: 1.2rem !important;
}

.blogtable tr,
.blogtable td {
  cursor: pointer !important;
}

.blogtable th {
  color: #b71c1c !important;
  font-weight: bold !important;
  background-color: #8c9da7 !important;
  font-family: "PT Sans", Sans-Serif;
}

.v-data-table__mobile-row__header {
  color: #b71c1c !important;
}

.blogtable {
  background-color: #dbe1f1 !important;
  width: 100% !important;
  padding-right: 5% !important;
}

.blogtable td:nth-child(1) {
  font-weight: bold;
}

.blogtable label {
  color: black !important;
  font-size: 1.3rem !important;
  cursor: pointer;
}

.blogtable tr:hover {
  background-color: #fffde7 !important;
}

.blogtable .search-title {
  cursor: pointer;
}
</style>
